// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../wallpaper/mb-smart-land-big.jpg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../../icon/brand/smart/smart.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
exports.push([module.id, "body{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-position:bottom}.ciam-brand-logo{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ");height:60px;width:45px}", ""]);
// Exports
module.exports = exports;
